import { render, staticRenderFns } from "./WsInfiniteScroll.vue?vue&type=template&id=45cae126&"
import script from "./WsInfiniteScroll.vue?vue&type=script&lang=js&"
export * from "./WsInfiniteScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports